"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Sidebar;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var sidebarStyle = __importStar(require("./Sidebar.module.scss"));
var react_router_dom_1 = require("react-router-dom");
var useCurrentLanguage_1 = require("@hooks/useCurrentLanguage");
var sidebarTranslator_1 = require("./localisation/sidebarTranslator");
var icons_1 = require("@assets/icons");
var NavigateButton_1 = __importDefault(require("@components/Buttons/NavigateButton/NavigateButton"));
var gddSlice_1 = require("@store/slices/gddSlice");
var authSlice_1 = require("@store/slices/authSlice");
var react_redux_1 = require("react-redux");
function Sidebar() {
    var _a = (0, react_1.useState)("General Info"), activeItem = _a[0], setActiveItem = _a[1];
    var navigate = (0, react_router_dom_1.useNavigate)();
    var currentLanguage = (0, useCurrentLanguage_1.useCurrentLanguage)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var loc = sidebarTranslator_1.sidebarTranslator[currentLanguage];
    function handleNavigate(route) {
        navigate(route);
    }
    function handleExitButtonClick() {
        dispatch((0, authSlice_1.setSelectedGDD)(null));
        dispatch((0, gddSlice_1.closeGDD)());
        navigate("/");
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: sidebarStyle.sidebar, children: [(0, jsx_runtime_1.jsxs)("ul", { children: [(0, jsx_runtime_1.jsx)("li", { children: (0, jsx_runtime_1.jsx)("span", { onClick: function () { return handleNavigate("editGdd"); }, children: loc.general }) }), (0, jsx_runtime_1.jsx)("li", { children: (0, jsx_runtime_1.jsx)("span", { onClick: function () { return handleNavigate("gameplay"); }, children: loc.gameplay }) }), (0, jsx_runtime_1.jsxs)("li", { children: [(0, jsx_runtime_1.jsx)("span", { onClick: function () { return handleNavigate("mechanics"); }, children: loc.mechanics }), (0, jsx_runtime_1.jsx)(NavigateButton_1.default, { route: "mechanics/new", icon: icons_1.icons.plus })] }), (0, jsx_runtime_1.jsxs)("li", { children: [(0, jsx_runtime_1.jsx)("span", { onClick: function () { return handleNavigate("locations"); }, children: loc.locations }), (0, jsx_runtime_1.jsx)(NavigateButton_1.default, { route: "locations/new", icon: icons_1.icons.plus })] }), (0, jsx_runtime_1.jsxs)("li", { children: [(0, jsx_runtime_1.jsxs)("span", { onClick: function () { return handleNavigate("characters"); }, children: [loc.characters, " "] }), (0, jsx_runtime_1.jsx)(NavigateButton_1.default, { route: "characters/new", icon: icons_1.icons.plus })] }), (0, jsx_runtime_1.jsx)("li", { children: (0, jsx_runtime_1.jsx)("span", { onClick: function () { return handleNavigate("info"); }, children: loc.output }) })] }), (0, jsx_runtime_1.jsx)("div", { className: sidebarStyle.button_wrapper, children: (0, jsx_runtime_1.jsx)("button", { className: sidebarStyle.go_back_button, onClick: handleExitButtonClick, children: icons_1.icons.exit }) })] }));
}
